import React, { useState } from "react";
import "../assets/fonts.css";
import { primaryGreen, secondeGreen } from "../utils/colors";
import { useNavigate } from "react-router-dom";
import Cookies from "universal-cookie";

const Header = ({ adminName }) => {
  const navigate = useNavigate();
  const [refreshState, setRefreshState] = useState(false);

  const cookies = new Cookies();

  const logout = () => {
    cookies.remove("jwt-auth");
    navigate("/");
  };

  // return (
  //   <div className="bg-white rounded-lg shadow-lg p-4 sm:p-6 mb-4 sm:mb-6 w-full">
  //     <div className="flex flex-col sm:flex-row items-center justify-between gap-4 sm:gap-6">
  //       <div className="flex items-center w-full sm:w-auto">
  //         <div className="bg-primary rounded-lg w-12 h-12 sm:w-16 sm:h-16 flex items-center justify-center text-white">
  //           <img
  //             src={require("../assets/maktabIcon.png")}
  //             alt="Logo"
  //             className="w-8 sm:w-10"
  //           />
  //         </div>
  //         <div className="mr-3 sm:mr-4">
  //           <h1 className="text-lg sm:text-xl font-bold text-gray-800">
  //             ابزار معلم
  //           </h1>
  //           <p className="text-sm sm:text-base text-gray-600">
  //             نام ادمین : {adminName}
  //           </p>
  //         </div>
  //       </div>
  //       <div className="w-full sm:w-auto">
  //         <button
  //           onClick={() => setRefreshState(!refreshState)}
  //           className={`w-full sm:w-auto bg-[${primaryGreen}] hover:bg-primary-dark text-white px-3 py-2 sm:px-4 sm:py-2 rounded-lg transition duration-200 text-sm sm:text-base`}
  //         >
  //           به روزرسانی
  //         </button>
  //       </div>
  //     </div>
  //   </div>
  // );
};

export default Header;
